//importing icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptopCode } from '@fortawesome/free-solid-svg-icons';
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import { faMicrochip } from '@fortawesome/free-solid-svg-icons';
import { faWindowRestore } from '@fortawesome/free-solid-svg-icons';
import { faAd } from '@fortawesome/free-solid-svg-icons';

const servicesData = () => {
    return [
        {
            icon: faLaptopCode,
            name: "Web Design & Development",
            description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum aspernatur reprehenderit"

        },
        {
            icon: faMobileAlt,
            name: "App Design & Development",
            description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum aspernatur reprehenderit"

        },
        {
            icon: faShieldAlt,
            name: "Cyber Security",
            description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum aspernatur reprehenderit"

        },
        {
            icon: faMicrochip,
            name: "Hardware",
            description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum aspernatur reprehenderit"

        },
        {
            icon: faWindowRestore,
            name: "Software",
            description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum aspernatur reprehenderit"

        },
        {
            icon: faAd,
            name: "Marketing & Exclusivity",
            description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum aspernatur reprehenderit"

        },
    ]
}

export default servicesData;
